import Flex from '@ilg-totallymoney/ui/components/Flex'
import Row from '@ilg-totallymoney/ui/components/Row'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

const SameDayDepositInfoBox = () => (
    <Row
        space="space10"
        backgroundColor="grey20"
        p="space10"
        borderRadius="borderRadius10"
        alignItems="center"
        width={['100%', 'fit-content']}
    >
        <Flex alignSelf="flex-start">
            <Icon icon="poundInCircle" size={16} color={theme.grey100} />
        </Flex>

        <Text variant="60" weight="bold" color="light">
            If approved, you could get your money in 1 working day. Subject to
            application and lender conditions.
        </Text>
    </Row>
)

export default SameDayDepositInfoBox
